import { useEffect, useState } from 'preact/hooks';
import type { SupabaseClient } from '@supabase/supabase-js';
import { AMBIENTE } from './supabase';
import type { Ir } from './rutas';
import { ultimoRespaldo } from './datos/respaldo';
import { hoy } from './logica/fechas';
import { estadoRespaldo } from './logica/respaldo';

type Resumen = { canales: number; colores: number; pedidos: number; clientes: number; productos: number };

export function Inicio({ sb, nombre, ir }: { sb: SupabaseClient; nombre: string; ir: Ir }) {
  const [r, setR] = useState<Resumen | null>(null);
  const [error, setError] = useState(''), [respaldo, setRespaldo] = useState<ReturnType<typeof estadoRespaldo> | null>(null);
  useEffect(() => {
    const cuenta = async (tabla: string) => {
      const { count, error } = await sb.from(tabla).select('*', { count: 'exact', head: true });
      if (error) throw error;
      return count || 0;
    };
    Promise.all(['pedidos', 'clientes', 'productos', 'canales', 'colores_tela'].map(cuenta))
      .then(([pedidos, clientes, productos, canales, colores]) => setR({ pedidos, clientes, productos, canales, colores }))
      .catch(e => setError('No se pudieron leer los datos: ' + (e.message || e)));
    ultimoRespaldo(sb).then(u => setRespaldo(estadoRespaldo(u, hoy(), true))).catch(() => {});
  }, []);
  return (
    <section class="panel" aria-label="Inicio">
      <h2>Hola, {nombre}</h2>
      <p class="estado conectada">Entraste con verificación en dos pasos.</p>
      {error ? <p class="error">{error}</p> : !r ? <p class="hint">Cargando…</p> : (
        <ul class="resumen">
          <li><b>{r.pedidos}</b> pedidos</li>
          <li><b>{r.clientes}</b> clientes</li>
          <li><b>{r.productos}</b> productos</li>
          <li><b>{r.canales}</b> canales de venta</li>
          <li><b>{r.colores}</b> colores de tela</li>
        </ul>
      )}
      {AMBIENTE === 'produccion' && r && r.pedidos > 0 && respaldo?.toca && <p class="nota" role="status">{respaldo.dias == null ? 'Todavía no has descargado ningún respaldo.' : `Hace ${respaldo.dias} días que no descargas un respaldo.`} <a href="#/ajustes/respaldo">Descargar respaldo</a></p>}
      <p class="hint">{AMBIENTE === 'pruebas' ? 'Ambiente de pruebas: lo que registres aquí es de práctica. ' : ''}Las secciones del menú se van activando una por una; las que dicen "próximo" se siguen haciendo en el prototipo.</p>
      <div class="acciones separado">
        <button class="btn primary" type="button" onClick={() => ir('pedido', 'nuevo')}>+ Nuevo pedido</button>
        <button class="btn" type="button" onClick={() => ir('pedidos')}>Ver pedidos</button>
        <button class="btn" type="button" onClick={() => ir('productos')}>Productos y precios</button>
      </div>
    </section>
  );
}
